import { render, staticRenderFns } from "./AnalyticsInvoiceItem.vue?vue&type=template&id=38b95bc7&scoped=true&"
import script from "./AnalyticsInvoiceItem.vue?vue&type=script&lang=ts&"
export * from "./AnalyticsInvoiceItem.vue?vue&type=script&lang=ts&"
import style0 from "./AnalyticsInvoiceItem.vue?vue&type=style&index=0&id=38b95bc7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38b95bc7",
  null
  
)

export default component.exports